import { createAction } from '@ngrx/store';

export const clearState = createAction(
  '[Main] Clear State'
);

export const redirectToMyAccountDashboard = createAction(
  '[Main] Redirect To MyAccount Dashboard'
);

export const redirectToMyAccountPayment = createAction(
  '[Main] Redirect To MyAccount Payment'
);

export type MainActionsUnion = ReturnType<typeof clearState | typeof redirectToMyAccountDashboard>;
